<app-question-template [form]="form" [question]="question">
	<ion-item>
		<ion-textarea
			(ionInput)="onChange($event)"
			autoGrow="true"
			type="text"
			[fill]="isV2() ? 'outline' : undefined"
			labelPlacement="stacked"
			label="{{ 'CHECKLISTS__QUESTIONS__TEXT__PLACEHOLDER' | transloco }}"
			#questionText
			required
		></ion-textarea>
	</ion-item>
</app-question-template>
